// Componente encargado de armar la página de preguntas
// ============
import React from 'react';
// ============
import Cabecera from '../../../components/Encuestas/Cabecera/Cabecera';
import DetalleEncuesta from '../../../components/Encuestas/DetalleEncuesta/DetalleEncuesta';
import Preguntas from '../../../components/Encuestas/Preguntas/Preguntas';
import MensajeInfoerror from '../MensajeInfoerror/MensajeInfoerror';

const FormularioEncuesta = ({ datos }) => {
  // Verificar si hay preguntas en la encuesta
  const tienePreguntas = datos?.encuesta?.preguntas && datos.encuesta.preguntas.length > 0;
  // Cada pregunta es una pantalla (sus adicionales van en la misma)
  const cantidadPreguntas = datos?.encuesta?.preguntas?.length ?? 0;

  // Return
  return (
    <>
      {datos.contestada ? (
        <>
          {(() => {
            const mensaje = {
              // Mensaje que se muestra si la encuesta solicitada ya está respondida
              titulo: '¡Encuesta respondida!',
              texto1: 'Gracias por tu feedback',
              texto2: datos?.encuesta?.cierre ? datos?.encuesta?.cierre : '',
              imagen: 2
            };
            return <MensajeInfoerror mensaje={mensaje} />;
          })()}
        </>
      ) : (
        <>
          {tienePreguntas ? ( // Generamos la pagina con la cabecera, la ficha del ticket y las preguntas
            <>
              <Cabecera
                tituloEncuesta={(datos?.encuesta?.titulo || '').trim()}
                subtitulo={`${cantidadPreguntas} ${cantidadPreguntas === 1 ? 'pregunta' : 'preguntas'} · menos de 1 minuto`}
              />
              <DetalleEncuesta
                numeroEncuesta={datos?.soporte?.numero || ''}
                fechaSolicitud={datos?.soporte?.fecha || ''}
                fechaCierre={datos?.soporte?.fechaResolucion || ''}
                cliente={datos?.soporte?.nombreCliente || ''}
                SolicitadaPor={datos?.soporte?.usuarioCliente || ''}
                RealizadaPor={datos?.soporte?.responsable || ''}
                Tema={datos?.soporte?.tarea || ''}
              />
              <Preguntas interrogantes={datos.encuesta.preguntas} datosCrudos={datos || ''} />
            </>
          ) : (
            <>
              {(() => {
                // Mensaje de error si la pregunta existe y no está respondida, pero el array de preguntas está vacío
                const mensaje = {
                  titulo: 'La encuesta está vacía',
                  texto1: 'Si estás viendo este mensaje, reportalo al soporte técnico',
                  imagen: 1
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
        </>
      )}
    </>
  );
};
export default FormularioEncuesta;
